import React from 'react';
import { IAiReplaceSlidePCService, ShowModalProps } from './ai-replace-slide-service.interface';
import Modal from '@tencent/dui/lib/components/Modal';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { ReplaceSlideCard } from './components/pc/replace-slide-content';
import { ReplaceSlidePCTitle } from './components/pc/title';
import { ISelectionService } from '../selection/selection-service.interface';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { IAIAssistantService } from '../ai-ssistant/ai-ssistant-service.interface';
import { TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

const MODAL_WIDTH = 416; // 浮窗参考宽度
const MODAL_HEIGHT = 320; // 浮窗参考高度
const PADDING_WIDTH = 40; // 浮窗和窗口的最小间距，用于浮窗定位

export class AiReplaceSlideServicePC implements IAiReplaceSlidePCService {
    private positionX?: number;
    private positionY?: number;

    public constructor(
        private uiDataService: IUiDataService,
        private selectionService: ISelectionService,
        private aiAssistantService: IAIAssistantService,
    ) {}

    public setDefaultPosition(x?: number, y?: number) {
        this.positionX = x;
        this.positionY = y;
    }

    public showModal({ onClose, position, location }: ShowModalProps) {
        const top = position?.y ?? this.positionY;
        const left = position?.x ?? this.positionX;
        const bottom = (top ?? 0) + MODAL_HEIGHT + PADDING_WIDTH;
        const right = (left ?? 0) + MODAL_WIDTH + PADDING_WIDTH;
        const finalLeft = left ? left - Math.max(0, (right ?? 0) - window.innerWidth) : left; // 避免弹窗超出窗口
        const finalTop = top ? top - Math.max(0, bottom - window.innerHeight) : top; // 避免弹窗超出窗口

        const modal = Modal.confirm({
            mask: false,
            style: {
                position: 'absolute',
                top: finalTop,
                left: finalLeft,
                width: MODAL_WIDTH,
                minHeight: MODAL_HEIGHT,
                padding: '12px 8px',
            },
            closable: false,
            title: null,
            header: <ReplaceSlidePCTitle />,
            content: (
                <ReplaceSlideCard
                    onClose={() => {
                        modal.close?.();
                        onClose?.();
                    }}
                    startCurrentId={this.selectionService.currentSlide?.id ?? ''}
                    uiDataService={this.uiDataService}
                    aiAssistantService={this.aiAssistantService}
                />
            ),
            footer: null,
            onClose: () => onClose?.(),
            destroyOnClose: true,
        });
        tdw({
            opername: TDWOperationType.DOC_PPT_AI,
            module: TDWModuleType.PAGE_BEAUTY,
            action: TDWActionType.CLK,
            ver5: TDWModuleType.PC,
            ver6: location,
        });
    }
}
